import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useSupportAuth } from "../context/SupportAuthContext";

const SupportLogin = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { loginSupport, setForcedLogoutReason, forcedLogoutReason } = useSupportAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email || !password) {
      enqueueSnackbar("Email and password are required.", { variant: "error" });
      return;
    }

    try {
      setLoading(true);
      setForcedLogoutReason("");
      const result = await loginSupport({ email, password });
      if (!result?.approved) {
        enqueueSnackbar("Waiting for admin approval", { variant: "info" });
        navigate("/support/waiting", { replace: true });
      }
    } catch (error) {
      enqueueSnackbar("Invalid credentials", {
        variant: "error",
        autoHideDuration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md bg-white rounded-lg shadow-lg border p-6"
      >
        <h1 className="text-2xl font-semibold text-center mb-6">Support Login</h1>
        {forcedLogoutReason ? (
          <div className="rounded-md border border-amber-200 bg-amber-50 text-amber-900 p-3 text-sm mb-4">
            {forcedLogoutReason}
          </div>
        ) : null}
        <label className="text-sm font-medium">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 mb-4 w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="support@example.com"
        />
        <label className="text-sm font-medium">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 mb-6 w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Enter password"
        />
        <button
          type="submit"
          disabled={loading}
          className={`w-full rounded-md py-2 text-white ${
            loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? "Submitting..." : "Login"}
        </button>
      </form>
    </div>
  );
};

export default SupportLogin;

